import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 32;

export default ({ color = defaultIconColor, opacity = 1, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={`${size}`} width={`${size}`} viewBox="0 0 37 37" {...props}>
    <path
      d="M34.5 11 10.556 34.943 2.5 35l.057-8.056 14.081-14.083-.114-.115-6.101 6.102-4.437-4.438L16.515 3.881l4.552 4.552L26.5 3z"
      stroke={`${color}`}
      strokeWidth="3"
      fill="none"
      fillRule="evenodd"
      opacity={`${opacity}`}
    />
  </svg>
);
